import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'
import { SaleReport } from '@/api_client/types/report'

export default async function getPerformancesReport(
  { client, config }: ApiContext,
  start_date,
  end_date,
): Promise<SaleReport> {
  const bearerToken = await getCurrentBearerToken({ client, config })

  const response = await client.report.performances(
    { bearerToken },
    { start_date, end_date },
  )
  if (response.isSuccess()) {
    return response.success()
  } else {
    return null
  }
}
